import React, { Component } from 'react';
import { FourthLevelHeading, HyperLink, Paragraph, Span, Box } from 'src/lib/StyledComponents';
import styles from './index.css';
import theme from 'src/lib/theme';

const InfoText = () => {
	const marketingWebsite = 'https://fundraisewisely.com';
	return (
		<Box
			backgroundColor={theme.colors['alice-blue']}
			color={theme.colors.wildBlue}
			fontSize={theme.fontSizes[4]}
			marginTop="5px"
			padding="12px"
			borderRadius={theme.radii.small}
		>
			<FourthLevelHeading>What data are we accessing?</FourthLevelHeading>
			<Paragraph fontSize={theme.fontSizes[4]} className={styles.InfoTextContent}>
				We copy data related to constituents, notes, gifts, opportunities, activities and
				relationships from your organization's CRM.
			</Paragraph>
			<FourthLevelHeading>What are we using it for?</FourthLevelHeading>
			<Paragraph fontSize={theme.fontSizes[4]} className={styles.InfoTextContent}>
				We use this data to create predictions on how much donors will give, to suggest
				prospects, and to prioritize your portfolio.
			</Paragraph>
			<FourthLevelHeading>What’s going to happen with your data?</FourthLevelHeading>
			<Paragraph fontSize={theme.fontSizes[4]} className={styles.InfoTextContent}>
				We transfer and maintain this data on cloud storage located inside the country or
				other governmental jurisdiction where your organization operates. We will write data
				back to your CRM only when you make an update (such as assigning a donor). We will
				not sell your data to a third party.
			</Paragraph>
			<Paragraph fontSize={theme.fontSizes[4]} className={styles.InfoTextFinal}>
				See more about how we{' '}
				<HyperLink
					href={`${marketingWebsite}/privacy-no-header`}
					target="_blank"
					rel="noopener noreferrer"
				>
					protect your data
				</HyperLink>
				.
			</Paragraph>
		</Box>
	);
};

class SyncInfo extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpen: false };
	}

	toggleCollapse = () => this.setState({ isOpen: !this.state.isOpen });

	render() {
		return (
			<React.Fragment>
				<Box
					onClick={this.toggleCollapse}
					color={theme.colors.wildBlue}
					fontSize={theme.fontSizes[4]}
					fontStyle="italic"
					cursor="pointer"
				>
					Understand what data we collect and why
					<Span marginLeft="5px">{this.state.isOpen ? '-' : '+'}</Span>
				</Box>
				{this.state.isOpen ? <InfoText /> : null}
			</React.Fragment>
		);
	}
}

export default SyncInfo;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/SyncInfo/index.js